// source: core/protos/material.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.vertexvis.protobuf.core.BasicColor', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.ColorMaterial', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.ColorMaterialf', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.DefaultMaterial', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.MaterialOverride', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.MaterialOverride.SealedValueOptionalCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.RGBAi', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.RGBf', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.core.RGBi', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.RGBAi = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.RGBAi, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.RGBAi.displayName = 'proto.vertexvis.protobuf.core.RGBAi';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.RGBi = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.RGBi, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.RGBi.displayName = 'proto.vertexvis.protobuf.core.RGBi';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.RGBf = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.RGBf, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.RGBf.displayName = 'proto.vertexvis.protobuf.core.RGBf';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.MaterialOverride = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.core.MaterialOverride.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.core.MaterialOverride, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.MaterialOverride.displayName = 'proto.vertexvis.protobuf.core.MaterialOverride';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.DefaultMaterial = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.DefaultMaterial, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.DefaultMaterial.displayName = 'proto.vertexvis.protobuf.core.DefaultMaterial';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.ColorMaterial = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.ColorMaterial, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.ColorMaterial.displayName = 'proto.vertexvis.protobuf.core.ColorMaterial';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.ColorMaterialf = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.ColorMaterialf, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.ColorMaterialf.displayName = 'proto.vertexvis.protobuf.core.ColorMaterialf';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.core.BasicColor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.core.BasicColor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.core.BasicColor.displayName = 'proto.vertexvis.protobuf.core.BasicColor';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.RGBAi.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.RGBAi} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.RGBAi.toObject = function(includeInstance, msg) {
  var f, obj = {
    r: jspb.Message.getFieldWithDefault(msg, 1, 0),
    g: jspb.Message.getFieldWithDefault(msg, 2, 0),
    b: jspb.Message.getFieldWithDefault(msg, 3, 0),
    a: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.RGBAi}
 */
proto.vertexvis.protobuf.core.RGBAi.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.RGBAi;
  return proto.vertexvis.protobuf.core.RGBAi.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.RGBAi} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.RGBAi}
 */
proto.vertexvis.protobuf.core.RGBAi.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setR(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setG(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setB(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setA(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.RGBAi.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.RGBAi} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.RGBAi.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getR();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getG();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getB();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getA();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional uint32 r = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.getR = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBAi} returns this
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.setR = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 g = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.getG = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBAi} returns this
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.setG = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 b = 3;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.getB = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBAi} returns this
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.setB = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 a = 4;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.getA = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBAi} returns this
 */
proto.vertexvis.protobuf.core.RGBAi.prototype.setA = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.RGBi.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.RGBi.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.RGBi} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.RGBi.toObject = function(includeInstance, msg) {
  var f, obj = {
    r: jspb.Message.getFieldWithDefault(msg, 1, 0),
    g: jspb.Message.getFieldWithDefault(msg, 2, 0),
    b: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.RGBi}
 */
proto.vertexvis.protobuf.core.RGBi.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.RGBi;
  return proto.vertexvis.protobuf.core.RGBi.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.RGBi} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.RGBi}
 */
proto.vertexvis.protobuf.core.RGBi.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setR(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setG(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setB(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.RGBi.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.RGBi.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.RGBi} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.RGBi.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getR();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getG();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getB();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional uint32 r = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBi.prototype.getR = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBi} returns this
 */
proto.vertexvis.protobuf.core.RGBi.prototype.setR = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 g = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBi.prototype.getG = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBi} returns this
 */
proto.vertexvis.protobuf.core.RGBi.prototype.setG = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 b = 3;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBi.prototype.getB = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBi} returns this
 */
proto.vertexvis.protobuf.core.RGBi.prototype.setB = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.RGBf.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.RGBf.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.RGBf} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.RGBf.toObject = function(includeInstance, msg) {
  var f, obj = {
    r: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    g: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    b: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.RGBf}
 */
proto.vertexvis.protobuf.core.RGBf.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.RGBf;
  return proto.vertexvis.protobuf.core.RGBf.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.RGBf} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.RGBf}
 */
proto.vertexvis.protobuf.core.RGBf.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setR(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setG(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setB(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.RGBf.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.RGBf.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.RGBf} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.RGBf.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getR();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getG();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getB();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional float r = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBf.prototype.getR = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBf} returns this
 */
proto.vertexvis.protobuf.core.RGBf.prototype.setR = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float g = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBf.prototype.getG = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBf} returns this
 */
proto.vertexvis.protobuf.core.RGBf.prototype.setG = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float b = 3;
 * @return {number}
 */
proto.vertexvis.protobuf.core.RGBf.prototype.getB = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.RGBf} returns this
 */
proto.vertexvis.protobuf.core.RGBf.prototype.setB = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.core.MaterialOverride.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.core.MaterialOverride.SealedValueOptionalCase = {
  SEALED_VALUE_OPTIONAL_NOT_SET: 0,
  DEFAULT_MATERIAL: 1,
  COLOR_MATERIAL: 2
};

/**
 * @return {proto.vertexvis.protobuf.core.MaterialOverride.SealedValueOptionalCase}
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.getSealedValueOptionalCase = function() {
  return /** @type {proto.vertexvis.protobuf.core.MaterialOverride.SealedValueOptionalCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.core.MaterialOverride.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.MaterialOverride.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.MaterialOverride} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.MaterialOverride.toObject = function(includeInstance, msg) {
  var f, obj = {
    defaultMaterial: (f = msg.getDefaultMaterial()) && proto.vertexvis.protobuf.core.DefaultMaterial.toObject(includeInstance, f),
    colorMaterial: (f = msg.getColorMaterial()) && proto.vertexvis.protobuf.core.ColorMaterial.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.MaterialOverride}
 */
proto.vertexvis.protobuf.core.MaterialOverride.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.MaterialOverride;
  return proto.vertexvis.protobuf.core.MaterialOverride.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.MaterialOverride} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.MaterialOverride}
 */
proto.vertexvis.protobuf.core.MaterialOverride.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.DefaultMaterial;
      reader.readMessage(value,proto.vertexvis.protobuf.core.DefaultMaterial.deserializeBinaryFromReader);
      msg.setDefaultMaterial(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.core.ColorMaterial;
      reader.readMessage(value,proto.vertexvis.protobuf.core.ColorMaterial.deserializeBinaryFromReader);
      msg.setColorMaterial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.MaterialOverride.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.MaterialOverride} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.MaterialOverride.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDefaultMaterial();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.DefaultMaterial.serializeBinaryToWriter
    );
  }
  f = message.getColorMaterial();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.core.ColorMaterial.serializeBinaryToWriter
    );
  }
};


/**
 * optional DefaultMaterial default_material = 1;
 * @return {?proto.vertexvis.protobuf.core.DefaultMaterial}
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.getDefaultMaterial = function() {
  return /** @type{?proto.vertexvis.protobuf.core.DefaultMaterial} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.DefaultMaterial, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.DefaultMaterial|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MaterialOverride} returns this
*/
proto.vertexvis.protobuf.core.MaterialOverride.prototype.setDefaultMaterial = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.core.MaterialOverride.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MaterialOverride} returns this
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.clearDefaultMaterial = function() {
  return this.setDefaultMaterial(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.hasDefaultMaterial = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ColorMaterial color_material = 2;
 * @return {?proto.vertexvis.protobuf.core.ColorMaterial}
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.getColorMaterial = function() {
  return /** @type{?proto.vertexvis.protobuf.core.ColorMaterial} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.ColorMaterial, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.ColorMaterial|undefined} value
 * @return {!proto.vertexvis.protobuf.core.MaterialOverride} returns this
*/
proto.vertexvis.protobuf.core.MaterialOverride.prototype.setColorMaterial = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.core.MaterialOverride.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.MaterialOverride} returns this
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.clearColorMaterial = function() {
  return this.setColorMaterial(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.MaterialOverride.prototype.hasColorMaterial = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.DefaultMaterial.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.DefaultMaterial.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.DefaultMaterial} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.DefaultMaterial.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.DefaultMaterial}
 */
proto.vertexvis.protobuf.core.DefaultMaterial.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.DefaultMaterial;
  return proto.vertexvis.protobuf.core.DefaultMaterial.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.DefaultMaterial} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.DefaultMaterial}
 */
proto.vertexvis.protobuf.core.DefaultMaterial.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.DefaultMaterial.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.DefaultMaterial.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.DefaultMaterial} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.DefaultMaterial.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.ColorMaterial.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.ColorMaterial} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ColorMaterial.toObject = function(includeInstance, msg) {
  var f, obj = {
    d: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ns: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ka: (f = msg.getKa()) && proto.vertexvis.protobuf.core.RGBi.toObject(includeInstance, f),
    kd: (f = msg.getKd()) && proto.vertexvis.protobuf.core.RGBi.toObject(includeInstance, f),
    ks: (f = msg.getKs()) && proto.vertexvis.protobuf.core.RGBi.toObject(includeInstance, f),
    ke: (f = msg.getKe()) && proto.vertexvis.protobuf.core.RGBi.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial}
 */
proto.vertexvis.protobuf.core.ColorMaterial.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.ColorMaterial;
  return proto.vertexvis.protobuf.core.ColorMaterial.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.ColorMaterial} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial}
 */
proto.vertexvis.protobuf.core.ColorMaterial.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setD(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNs(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.RGBi;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBi.deserializeBinaryFromReader);
      msg.setKa(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.core.RGBi;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBi.deserializeBinaryFromReader);
      msg.setKd(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.RGBi;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBi.deserializeBinaryFromReader);
      msg.setKs(value);
      break;
    case 6:
      var value = new proto.vertexvis.protobuf.core.RGBi;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBi.deserializeBinaryFromReader);
      msg.setKe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.ColorMaterial.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.ColorMaterial} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ColorMaterial.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getD();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNs();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getKa();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.RGBi.serializeBinaryToWriter
    );
  }
  f = message.getKd();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.core.RGBi.serializeBinaryToWriter
    );
  }
  f = message.getKs();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.RGBi.serializeBinaryToWriter
    );
  }
  f = message.getKe();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.vertexvis.protobuf.core.RGBi.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 d = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.getD = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.setD = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 ns = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.getNs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.setNs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional RGBi ka = 3;
 * @return {?proto.vertexvis.protobuf.core.RGBi}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.getKa = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBi} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBi, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
*/
proto.vertexvis.protobuf.core.ColorMaterial.prototype.setKa = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.clearKa = function() {
  return this.setKa(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.hasKa = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RGBi kd = 4;
 * @return {?proto.vertexvis.protobuf.core.RGBi}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.getKd = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBi} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBi, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
*/
proto.vertexvis.protobuf.core.ColorMaterial.prototype.setKd = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.clearKd = function() {
  return this.setKd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.hasKd = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RGBi ks = 5;
 * @return {?proto.vertexvis.protobuf.core.RGBi}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.getKs = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBi} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBi, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
*/
proto.vertexvis.protobuf.core.ColorMaterial.prototype.setKs = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.clearKs = function() {
  return this.setKs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.hasKs = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RGBi ke = 6;
 * @return {?proto.vertexvis.protobuf.core.RGBi}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.getKe = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBi} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBi, 6));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBi|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
*/
proto.vertexvis.protobuf.core.ColorMaterial.prototype.setKe = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterial} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.clearKe = function() {
  return this.setKe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ColorMaterial.prototype.hasKe = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.ColorMaterialf.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.ColorMaterialf} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ColorMaterialf.toObject = function(includeInstance, msg) {
  var f, obj = {
    d: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    ns: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    ka: (f = msg.getKa()) && proto.vertexvis.protobuf.core.RGBf.toObject(includeInstance, f),
    kd: (f = msg.getKd()) && proto.vertexvis.protobuf.core.RGBf.toObject(includeInstance, f),
    ks: (f = msg.getKs()) && proto.vertexvis.protobuf.core.RGBf.toObject(includeInstance, f),
    ke: (f = msg.getKe()) && proto.vertexvis.protobuf.core.RGBf.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.ColorMaterialf;
  return proto.vertexvis.protobuf.core.ColorMaterialf.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.ColorMaterialf} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setD(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setNs(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.core.RGBf;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBf.deserializeBinaryFromReader);
      msg.setKa(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.core.RGBf;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBf.deserializeBinaryFromReader);
      msg.setKd(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.core.RGBf;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBf.deserializeBinaryFromReader);
      msg.setKs(value);
      break;
    case 6:
      var value = new proto.vertexvis.protobuf.core.RGBf;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBf.deserializeBinaryFromReader);
      msg.setKe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.ColorMaterialf.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.ColorMaterialf} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.ColorMaterialf.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getD();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getNs();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getKa();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.core.RGBf.serializeBinaryToWriter
    );
  }
  f = message.getKd();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.core.RGBf.serializeBinaryToWriter
    );
  }
  f = message.getKs();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.vertexvis.protobuf.core.RGBf.serializeBinaryToWriter
    );
  }
  f = message.getKe();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.vertexvis.protobuf.core.RGBf.serializeBinaryToWriter
    );
  }
};


/**
 * optional float d = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.getD = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.setD = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float ns = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.getNs = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.setNs = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional RGBf ka = 3;
 * @return {?proto.vertexvis.protobuf.core.RGBf}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.getKa = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBf} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBf, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBf|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
*/
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.setKa = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.clearKa = function() {
  return this.setKa(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.hasKa = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RGBf kd = 4;
 * @return {?proto.vertexvis.protobuf.core.RGBf}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.getKd = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBf} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBf, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBf|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
*/
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.setKd = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.clearKd = function() {
  return this.setKd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.hasKd = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RGBf ks = 5;
 * @return {?proto.vertexvis.protobuf.core.RGBf}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.getKs = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBf} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBf, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBf|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
*/
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.setKs = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.clearKs = function() {
  return this.setKs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.hasKs = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RGBf ke = 6;
 * @return {?proto.vertexvis.protobuf.core.RGBf}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.getKe = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBf} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBf, 6));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBf|undefined} value
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
*/
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.setKe = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.ColorMaterialf} returns this
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.clearKe = function() {
  return this.setKe(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.ColorMaterialf.prototype.hasKe = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.core.BasicColor.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.core.BasicColor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.core.BasicColor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BasicColor.toObject = function(includeInstance, msg) {
  var f, obj = {
    baseColor: (f = msg.getBaseColor()) && proto.vertexvis.protobuf.core.RGBf.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.core.BasicColor}
 */
proto.vertexvis.protobuf.core.BasicColor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.core.BasicColor;
  return proto.vertexvis.protobuf.core.BasicColor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.core.BasicColor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.core.BasicColor}
 */
proto.vertexvis.protobuf.core.BasicColor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.core.RGBf;
      reader.readMessage(value,proto.vertexvis.protobuf.core.RGBf.deserializeBinaryFromReader);
      msg.setBaseColor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.core.BasicColor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.core.BasicColor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.core.BasicColor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.core.BasicColor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBaseColor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.core.RGBf.serializeBinaryToWriter
    );
  }
};


/**
 * optional RGBf base_color = 1;
 * @return {?proto.vertexvis.protobuf.core.RGBf}
 */
proto.vertexvis.protobuf.core.BasicColor.prototype.getBaseColor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RGBf} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.core.RGBf, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RGBf|undefined} value
 * @return {!proto.vertexvis.protobuf.core.BasicColor} returns this
*/
proto.vertexvis.protobuf.core.BasicColor.prototype.setBaseColor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.core.BasicColor} returns this
 */
proto.vertexvis.protobuf.core.BasicColor.prototype.clearBaseColor = function() {
  return this.setBaseColor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.core.BasicColor.prototype.hasBaseColor = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.vertexvis.protobuf.core);
